import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';
import { ReactElement } from 'react';
import { PlanInterval } from '../../../models';
import ProductQuotaSelection from './ProductQuotaSelection';

export interface SubProductItemProps {
  subProductIcon: ReactElement,
  subProductId: string;
  unitPrice: Partial<Record<PlanInterval, number>>;
  disabled: boolean;
}

const SubProductItem = (
  {
    subProductIcon,
    subProductId,
    unitPrice,
    disabled,
  } : SubProductItemProps,
) => (
  <Box
    id={`product-item-sub-products-${subProductId}`}
    display="flex"
    flexDirection="column"
    paddingY={2}
    alignContent="center"
    alignItems="center"
  >
    <Box
      id={`product-item-sub-products-${subProductId}-header`}
      width="100%"
      paddingRight={0}
      display="flex"
      flexDirection="row"
      alignContent="center"
    >
      {subProductIcon}
      <Typography
        variant="body1"
        fontWeight={400}
        fontSize={14}
        paddingX={2}
      >
        <FormattedMessage id={`page.expand.plan.product.${subProductId}.title`} />
      </Typography>
    </Box>
    <Box
      id={`product-item-${subProductId}-quota-selection`}
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      paddingTop={2}
      width="100%"
    >
      <ProductQuotaSelection
        productId={subProductId}
        price={unitPrice}
        disabled={disabled}
      />
    </Box>
  </Box>
);

export default SubProductItem;
